import React from 'react';
import './Aboutsection.css';
import { Link } from 'react-router-dom';
import About1 from '../src/images/About1.png';

const Aboutsection = () => {
    return (
        <section className="nd-about-section">
            <div className="container">
                <div className="row align-items-stretch g-4 g-lg-5 nd-about-row">
                    {/* Image Column */}
                    <div className="col-lg-6 order-lg-1 order-2 d-flex">
                        <div className="nd-about-visual-wrapper">
                            <div className="nd-about-visual-card">
                                <img
                                    src={About1}
                                    alt="About N D Techland"
                                    className="nd-about-img"
                                />
                                <div className="nd-floating-tag">
                                    <div className="nd-tag-icon">
                                        <i className="fa fa-layer-group"></i>
                                    </div>
                                    <div className="nd-tag-content">
                                        <h4>N D Connect</h4>
                                        <span>Connects The Tech Dots</span>
                                    </div>
                                </div>
                            </div>
                            <div className="nd-visual-glow"></div>
                        </div>
                    </div>

                    {/* Content Column */}
                    <div className="col-lg-6 order-lg-2 order-1 d-flex flex-column justify-content-center">
                        <div className="nd-about-content">
                            <div className="nd-section-badge">
                                <i className="fa fa-info-circle me-2"></i>
                                <span>About Us</span>
                            </div>

                            <h2 className="nd-about-title">
                                About <span className="nd-gradient-text">N D Techland Private Limited</span>
                            </h2>

                            <p className="nd-about-text">
                                At N D Techland Private Limited, we specialize in developing innovative software solutions that empower businesses to reach their full potential. Our commitment to excellence and customer satisfaction drives us to create products that solve real-world challenges and help our clients thrive in a competitive market.
                            </p>

                            <p className="nd-about-text">
                                N D Connect is more than just software; it's a strategic partner in your business's success. Whether you're a small business or a large enterprise, our platform adapts to your needs and scales as you grow.
                            </p>

                            <div className="nd-about-cta-card">
                                <h4 className="nd-cta-heading">Get Started Today</h4>
                                <p className="nd-cta-text">
                                    Ready to take control of your business operations? Experience the power of N D Connect. Contact us today to learn more or to schedule a demo. Let us help you manage your business more efficiently and effectively.
                                </p>
                                <div className="nd-cta-btn-wrap">
                                    <Link to="/Contactus" className="nd-btn-primary">
                                        <span>Contact Us</span>
                                        <i className="fa fa-arrow-right ms-2"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Aboutsection;
